import axios from 'axios'

/**
 * 管理端请求实例
 *
 * 与 C 端 request.js 分开，原因是两者的鉴权头与失败语义完全不同：
 * C 端 code=0 表示成功、失败给提示即可；管理端 code=400 表示令牌失效，
 * 必须立刻清掉本地令牌并把人送回登录页，否则页面会一直显示空列表，看着像「没有数据」。
 *
 * 令牌头用 Admin-Authorization 而不是 Authorization：同一浏览器里 C 端登录页
 * 也会带 Authorization，混用会让「谁的身份」变得说不清。
 */

export const ADMIN_TOKEN_KEY = 'mo-sso-admin-token'
export const ADMIN_NAME_KEY = 'mo-sso-admin-name'

export function getAdminToken() {
  return window.localStorage.getItem(ADMIN_TOKEN_KEY) || ''
}

export function setAdminSession(token, username) {
  window.localStorage.setItem(ADMIN_TOKEN_KEY, token || '')
  if (username) {
    window.localStorage.setItem(ADMIN_NAME_KEY, username)
  }
}

export function clearAdminSession() {
  window.localStorage.removeItem(ADMIN_TOKEN_KEY)
  window.localStorage.removeItem(ADMIN_NAME_KEY)
}

export function getAdminName() {
  return window.localStorage.getItem(ADMIN_NAME_KEY) || 'admin'
}

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 20000
})

service.interceptors.request.use(config => {
  const token = getAdminToken()
  if (token) {
    config.headers['Admin-Authorization'] = token
  }
  return config
})

service.interceptors.response.use(
  response => {
    const body = response.data || {}
    if (body.code === 400) {
      clearAdminSession()
      // 不用 router.push：这里引用 router 会与「路由 → 页面 → 接口」形成循环依赖，
      // 失效重登本来就要丢弃整个页面状态，整页跳转反而更干净
      if (window.location.pathname.indexOf('/admin/login') !== 0) {
        window.location.replace('/admin/login')
      }
      return Promise.reject(new Error(body.message || '登录已失效，请重新登录'))
    }
    return body
  },
  error => {
    const message = error && error.response
      ? `请求失败（HTTP ${error.response.status}）`
      : '网络异常，请检查服务是否可访问'
    return Promise.reject(new Error(message))
  }
)

export default service
